<template>
  <div v-if="showTransferSection || showCadSection">
    <div
      v-if="showTransferSection"
      class="od-card"
    >
      <div class="od-card-header">
        <div class="od-card-header-left">
          <a-icon type="credit-card" class="od-card-header-icon" />
          <p class="od-card-header-title">
            Metode Pembayaran
          </p>
        </div>
      </div>
      <div class="od-card-body">
        <div class="od-info-grid od-mb-6">
          <span class="od-info-label">Tipe Pembayaran</span>
          <span class="od-info-value od-text-blue">
            <template v-if="order.payment_type === 'BANK_TRANSFER'">Bank Transfer</template>
            <template v-else-if="order.payment_type === 'EWALLET'">{{ order.payment_name }}</template>
            <template v-else>Virtual Account</template>
          </span>

          <template v-if="order.payment_type !== 'EWALLET'">
            <span class="od-info-label">Bank</span>
            <span class="od-info-value">{{ (order.payment_method && order.payment_method.bank_name) || '-' }}</span>

            <span class="od-info-label">No. Rekening</span>
            <div class="od-flex od-flex-center od-gap-2">
              <span class="od-info-value">{{ (order.payment_method && order.payment_method.account_number) || '-' }}</span>
              <button class="od-copy-btn" @click="copyToClipboard(String((order.payment_method && order.payment_method.account_number) || '-'), 'No. Rekening')">
                <a-icon type="copy" /> Salin
              </button>
            </div>
          </template>
        </div>

        <div v-if="order.payment_type === 'EWALLET'" class="od-qr-box od-mb-4">
          <div v-if="order.payment_method && order.payment_method.qr_code">
            <p class="od-text-sm od-font-bold" style="color:#374151;margin-bottom:8px;">
              Scan QR Code untuk Pembayaran
            </p>
            <div style="background:#fff;padding:16px;border-radius:12px;border:1px solid #f3f4f6;">
              <img :src="order.payment_method.qr_code" style="width:192px;height:192px;object-fit:contain;" />
            </div>
          </div>
          <a
            v-if="order.payment_method && order.payment_method.deep_link_redirect"
            :href="order.payment_method.deep_link_redirect"
            target="_blank"
            style="display:block;background:#3b82f6;color:#fff;padding:12px 24px;border-radius:999px;font-weight:700;text-align:center;text-decoration:none;width:100%;"
          >
            Bayar Melalui Aplikasi
          </a>
        </div>

        <div v-if="order.payment_type === 'BANK_TRANSFER'" class="od-payment-dashed">
          <div class="od-upload-row">
            <div class="od-upload-info">
              <p class="od-upload-title">
                Bukti Pembayaran
              </p>
              <p class="od-upload-hint">
                Foto bukti transfer
              </p>
            </div>
            <div
              class="od-proof-thumb"
              :style="(order.payment_proof_url) ? 'cursor:pointer;' : 'cursor:default;'"
              @click="order.payment_proof_url && $emit('showProof', order.payment_proof_url)"
            >
              <template v-if="order.payment_proof_url">
                <img :src="order.payment_proof_url" />
              </template>
              <div v-else class="od-proof-thumb-empty">
                <a-icon type="upload" />
                <p>Belum ada bukti</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="showCadSection" class="od-card">
      <div class="od-card-header">
        <div class="od-card-header-left">
          <a-icon type="credit-card" class="od-card-header-icon" />
          <p class="od-card-header-title">
            Informasi Penagihan
          </p>
        </div>
      </div>
      <div class="od-card-body">
        <p style="font-size:10px;font-weight:900;color:#9ca3af;text-transform:uppercase;letter-spacing:0.2em;margin-bottom:12px;">
          TAGIHAN CREDIT LIMIT
        </p>
        <div class="od-info-grid od-mb-4">
          <span class="od-info-label">Status Tagihan</span>
          <div>
            <span class="od-badge" :class="getPurchaseStatusClass((mixPaymentData && mixPaymentData.credit_limit_status) || order.payment_state)">
              {{ getPaymentStatusLabel((mixPaymentData && mixPaymentData.credit_limit_status) || order.payment_state) }}
            </span>
          </div>
          <span class="od-info-label">Total Tagihan</span>
          <span class="od-info-value">{{ toCurrency((mixPaymentData && mixPaymentData.credit_limit_amount) || (order.payment_data && order.payment_data.credit_limit_usage) || order.gross_total) }}</span>
        </div>

        <template v-if="order.payment_data && order.payment_data.mix_payment_method_id">
          <hr class="od-section-divider" />
          <p style="font-size:10px;font-weight:900;color:#9ca3af;text-transform:uppercase;letter-spacing:0.2em;margin-bottom:12px;">
            SISA PEMBAYARAN
          </p>
          <div class="od-info-grid od-mb-4">
            <span class="od-info-label">Status Sisa Pembayaran</span>
            <div>
              <span class="od-badge" :class="getPurchaseStatusClass((mixPaymentData && mixPaymentData.status) || (order.payment_state === 'PAID' ? 'PAID' : 'UNPAID'))">
                {{ getPaymentStatusLabel((mixPaymentData && mixPaymentData.status) || (order.payment_state === 'PAID' ? 'PAID' : 'UNPAID')) }}
              </span>
            </div>
            <span class="od-info-label">Total Pembayaran</span>
            <span class="od-info-value">{{ toCurrency((mixPaymentData && mixPaymentData.amount) || (order.gross_total - ((order.payment_data && order.payment_data.credit_limit_usage) || 0))) }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderPaymentInfo',
  props: {
    order: { type: Object, default: null },
    mixPaymentData: { type: Object, default: null },
    isPaid: { type: Boolean, default: false },
    toCurrency: { type: Function, required: true },
    getPurchaseStatusClass: { type: Function, required: true },
    getPaymentStatusLabel: { type: Function, required: true },
    copyToClipboard: { type: Function, required: true },
  },
  computed: {
    showTransferSection() {
      const term = this.order.payment_data && this.order.payment_data.term
      return (
        (term && (term.includes('TRANSFER') || term.includes('VA') || term.includes('CBD'))) ||
        this.order.payment_type === 'EWALLET'
      )
    },
    showCadSection() {
      const term = this.order.payment_data && this.order.payment_data.term
      return term === 'CAD' || this.order.payment_type === 'CAD'
    },
  },
}
</script>
